<template>
  <div class="main_box">
    <div>
      <div class="main_tabs_box">
        <ul class="main_tabs small_tabs">
          <!-- 
            sellOrderType:
            1=To be paid 待付款,  2=Shipping 待发货,        3=Shipped 待收货,
            4=Processing 维权中， 5=To be reviewed 待评价， 6=交易完成或关闭，
            7=交易完成，          8=交易关闭                申请累积 = 20
          -->
          <li v-for="(obj, k) in tabList" :key="k" :index="k" @click="MsgTabs(obj.type, obj.label)" :class="[sellOrderType == obj.type ? 'on' : '', k == 0 && obj.label == 'All' ? 'width_big' : '']">
            {{ obj.label }}
            <span v-if="obj.showCont && obj['count'] && TabCont[obj['count']] > 0">({{ TabCont[obj['count']] }})</span>
          </li>
        </ul>
      </div>
      <div class="search-box">
        <el-form ref="form" class="flex_form">
          <div>
            {{ $t('enum.title') }}
            <el-input class="store_ipt" v-model="Title" :placeholder="$t('enum.itemTitle')"></el-input>
          </div>
          <div>
            {{ $t('enum.orderNum') }}
            <el-input class="store_ipt" v-model="OrderNo" :placeholder="$t('enum.orderNumber')"></el-input>
          </div>
          <div>
            {{ $t('enum.buyerID') }}
            <el-input class="store_ipt" v-model="RealName" :placeholder="$t('enum.buyerName')"></el-input>
          </div>
          <div class="store_btn primary" @click="getData">{{ $t('button.search') }}</div>
        </el-form>
        <div>{{Count}} {{Count!=1 ? $t('enum.items'):$t('enum.item')}}</div>
      </div>
      <div v-if="List.length > 0">
        <div class="order_overflow" ref="orderTopList">
          <div class="order_title" ref="orderTitle" :class="sellOrderType == 2 ? 'order_min_w' : ''">
            <div class="order_list">
              <div class="card_detail">
                <div class="cd_info com_box" style="width:88px;"></div>
                <div class="cd_info com_box" style="min-width:200px;flex: 1;">{{ $t('enum.commodity') }}</div>
                <div class="cd_info align_r">{{ $t('enum.itemPrice') }}</div>
                <div class="cd_info shipment align_r">{{ $t('enum.shippingFee') }}</div>
                <div class="cd_info align_r">{{ $t('enum.orderTotal') }}</div>
                <div class="cd_info align_r order_state" v-if="sellOrderType == 6">{{ $t('enum.state') }}</div>
                <div class="cd_info align_r" v-if="sellOrderType == 0 || sellOrderType == 2">{{ $t('enum.timeToShip') }}</div>
                <div class="cd_info operate order_operate" style="width:148px;">{{ $t('enum.operate') }}</div>
              </div>
              <!-- <div class="operate order_operate">Operate</div> -->
            </div>
            <!-- <h4>{{tabname}}</h4> -->
          </div>
          <!-- :style="{'height':screenHeight+'px'}" -->
          <order-list ref="OrderList" @refresh="refresh" @MsgTabs="MsgTabs" :tabList="tabList" :list="List" :tabname="tabname" v-loading="loading" />
        </div>
        <list-pagination v-show="Count > 0" ref="Pagination" :total="Count" @getData="getData" />
      </div>
      <div v-else class="no-data">{{ loading ? $t('enum.loading')+"..." : $t('enum.noData') }}</div>

    </div>

  </div>
</template>

<script>

import OrderList from '@/components/orderlist'
import ListPagination from '@/components/listpagination'
export default {
  name: '',
  components: { OrderList, ListPagination },
  data() {
    return {
      loading: true, //page loading
      UserInfo: this.$store.state.UserInfo,
      msgTabs: 1,
      tabList: [
        { type: 0, label: this.$t('enum.all'), cnName: "全部", count: "", showCont: false },
        { type: 1, label: this.$t('enum.waitingForPayments'), cnName: "待支付", count: "ToBePaidCount", showCont: false },
        { type: 2, label: this.$t('enum.toBeShipped'), cnName: "待发货", count: "ShippingCount", showCont: true },
        { type: 3, label: this.$t('enum.shipped'), cnName: "待收货", count: "ShippedCount", showCont: false },
        { type: 4, label: this.$t('enum.dispute'), cnName: "维权中", count: "ProcessingCount", showCont: true },
        { type: 5, label: this.$t('enum.toLeaveFeedback'), cnName: "待评价", count: "ToBeReviewedCount", showCont: true },
        { type: 6, label: this.$t('enum.completed'), cnName: "已完成", count: "FinishedCount", showCont: false },
        { type: 8, label: this.$t('enum.closed'), cnName: "已关闭", count: "FinishedCount", showCont: false },
      ], //tab
      List: [],
      Count: 0,
      PageIndex: 1,
      PageSize: 60,
      sellOrderType: 0,//1=To be paid 待付款,2=Shipping 待发货,3=Shipped 待收货,4=Processing 维权中，5=To be reviewed 待评价
      OrderNo: '',//订单编号
      RealName: '',//买卖昵称
      BeginDate: '',//开始日期（订单创建时间）
      EndDate: '',//结束日期（订单创建时间）
      Title: '',//商品名称或编号
      TabCont: {
        ToBePaidCount: 0,
        ShippingCount: 0,
        ShippedCount: 0,
        ProcessingCount: 0,
        ToBeReviewedCount: 0,
        FinishedCount: 0,
      },
      dialogTitle: "",
      dialogType: "",
      dialogVisible: false,
      tabname: "To be paid",
      // screenHeight: 200,
      widthCount: 0,
    }
  },
  created() {
    var that = this;
    const sellParams = this.$route.params.sellOrderType ? this.$route.params.sellOrderType : '';
    if (sellParams) {
      this.sellOrderType = sellParams;
    }
    that.$store.dispatch("getExchange")
    // that.$store.dispatch("getExchangeRate")
  },
  mounted() {
    var that = this;
    that.getData();
    that.getSellStatistics();
    that.getExpressShipper();
    //this.refresh()

    // window.addEventListener('resize',()=>{
    //   this.tabHeight()
    // })
  },
  methods: {
    // 获取快递公司和编号
    getExpressShipper() {
      var that = this;
      var hasExpressShipper = that.$cookie.get('Card_ExpressShipper') ? that.$cookie.get('Card_ExpressShipper') : false;
      var ExpressShipperData = window.localStorage.getItem("Card_ExpressShipper") ? JSON.parse(window.localStorage.getItem("Card_ExpressShipper")) : [];
      if (!hasExpressShipper || ExpressShipperData.length <= 0) {
        that.$get('GetExpressShipper', '?shipperType=1', 'UserApi')
          .then((res) => {
            if (res.Result) {
              that.$cookie.set('Card_ExpressShipper', true, { Path: "/" });//是否保存过快递列表
              window.localStorage.setItem("Card_ExpressShipper", JSON.stringify(res.Data))//将快递列表保存至本地缓存
              that.$store.state.ExpressShipper = res.Data;
              // console.log("axios-GetExpressShipper:", res.Data);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        that.$store.state.ExpressShipper = ExpressShipperData;
        // console.log("ExpressShipperData-localStorage", ExpressShipperData);
      }
    },
    //获取卖家订单统计
    getSellStatistics() {
      var that = this;//订单统计
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        /*
          0：To be paid 待付款条数,
          1：Shipping 待发货条数,
          2：Shipped 待收货条数,
          3：Processing 维权中条数，
          4：To be reviewed 待评价条数，
          5：数据总条数
          6：交易完成条数
        */
        if (res.result) {
          var _data = res.data;
          that.$set(that.TabCont, "ToBePaidCount", _data[0]);
          that.$set(that.TabCont, "ShippingCount", _data[1]);
          that.$set(that.TabCont, "ShippedCount", _data[2]);
          that.$set(that.TabCont, "ProcessingCount", _data[3]);
          that.$set(that.TabCont, "ToBeReviewedCount", _data[4]);
          that.$set(that.TabCont, "FinishedCount", _data[6]);
        }
      };
      that.$get('GetSellStatistics')//卖家订单统计
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 获取卖家订单
    getData(PageIndex, PageSize) {
      var that = this;//卖家订单查询
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&sellOrderType=${that.sellOrderType}&Title=${that.Title}&RealName=${that.RealName}&OrderNo=${that.OrderNo}&BeginDate=${that.BeginDate}&EndDate=${that.EndDate}`;
      that.loading = true;
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        if (res.result) {
          var _data = res.data
          that.List = _data;
          that.Count = res.count;
          setTimeout(() => {
            if (res.count > 0) {
              that.$refs.OrderList.sellOrderType = that.sellOrderType;
              that.$refs.orderTopList.scrollTo(0, 0)
            }
          }, 500);
        }
      };
      that.$get('SearchSellOrders', params)//卖家订单查询
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 根据状态获取筛选卖家订单
    MsgTabs(val, name) {
      let that = this;
      that.sellOrderType = val;
      // that.$refs.OrderList.sellOrderType = val;
      that.tabname = name;
      that.PageIndex = 1;
      that.getData();
    },
    // 获取order_title 长度
    refresh(val) {
      this.titleWidth = val
      this.$nextTick(function () {
        this.$refs.orderTitle.style.width = this.titleWidth + 'px'
      });
    },
    dialog(val, obj) {
      // this.dialogVisible = true;
      // this.sellOrderType = val;
      // if (val == 1) this.dialogTitle = "Return shipping info"
      // if (val == 2) this.dialogTitle = "Ship"
      // if (val == 3) this.dialogTitle = "Card Description"
      // if (val == 4) this.dialogTitle = "Edit shipping fee"
      // if (val == 5) this.dialogTitle = "To be Reviewed"
      // console.log(val, obj)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/orderlist.css";

.search-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
}

.order_overflow {
  overflow-x: auto;
}

.OrderList {
  overflow-y: auto;
}

.order_list {
  height: 48px;
  line-height: 48px;
  background-color: #f7f7f7;
}

.order_title {
  margin: 0 0 20px;
  /* position: fixed; */
  z-index: 1;
}

.order_list>div {
  line-height: 48px;
}

.order_list .com_box {
  text-align: center;
  display: block;
}

.flex_form {
  display: flex;
  margin: 20px 0;
}

.flex_form>div {
  margin-right: 34px;
}

.flex_form .el-input {
  margin: 0 0 0 7px;
}

.store_ipt {
  width: 150px;
}

.store_btn {
  padding: 0 20px;
  height: 36px;
  line-height: 34px;
  color: #333;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
  margin-right: 8px;
}

.primary {
  background-color: #5f6dae;
  border-color: #5f6dae;
  color: #fff;
}

/deep/ .dialog_box {
  margin: 0 40px;
}

/deep/ .sh_fee {
  margin: 0;
  width: 100%;
  -webkit-box-pack: initial;
  justify-content: normal;
}

/deep/ .sh_fee div:first-child {
  margin: 0 12px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/index.vue